module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "barRef",
    staticClass: "my-progress-bar",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.progressClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "bar-inner"
  }, [_c('div', {
    ref: "progressRef",
    staticClass: "progress"
  }), _vm._v(" "), _c('div', {
    ref: "btnRef",
    staticClass: "progress-btn-wrapper",
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        _vm.progressTouchstart($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        _vm.progressTouchmove($event)
      },
      "touchend": _vm.progressTouchend
    }
  }, [_c('div', {
    staticClass: "progress-btn"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-58f4f970","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/base/MyProgressBar/MyProgressBar.vue
// module id = 481
// module chunks = 9